export default __webpack_public_path__ + "static/media/more_info_brake_bad.25d11ce4.png";